import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d2fe351"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PhotoSettings z-photo-settings" }
const _hoisted_2 = { class: "Overlay" }
const _hoisted_3 = {
  key: 0,
  id: "PhotoSettings-corner",
  fill: "none",
  width: "83",
  height: "84",
  viewBox: "0 0 83 84"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M82.3676 2.13991L20.7029 2.1399C10.434 2.13989 2.10937 10.4645 2.10937 20.7334L2.10936 83.0916",
  stroke: "white",
  "stroke-width": "2.32419"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M30.9687 25.1812V25.1812C27.6464 25.1812 24.9531 27.9264 24.9531 31.2487V31.2487",
  stroke: "white",
  "stroke-width": "1.54946",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  id: "PhotoSettings-corner",
  fill: "none",
  width: "83",
  height: "84",
  viewBox: "0 0 83 84"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  stroke: "#fff",
  "stroke-width": "3",
  d: "M31.2923 2H26C12.7452 2 2 12.7452 2 26V31.2923"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { id: "PhotoSettings-frame" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "100%",
  height: "100%",
  fill: "white"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  class: "Overlay__Frame",
  width: "100%",
  height: "100%",
  mask: "url(#PhotoSettings-frame)"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<defs data-v-2d2fe351><filter id=\"PhotoSettings-gridShadow\" color-interpolation-filters=\"sRGB\" filterUnits=\"userSpaceOnUse\" data-v-2d2fe351><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-2d2fe351></feFlood><feColorMatrix in=\"SourceAlpha\" result=\"hardAlpha\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" data-v-2d2fe351></feColorMatrix><feOffset dx=\"1\" dy=\"1\" data-v-2d2fe351></feOffset><feGaussianBlur stdDeviation=\"1\" data-v-2d2fe351></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-2d2fe351></feComposite><feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-2d2fe351></feColorMatrix><feBlend in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_353_5142\" data-v-2d2fe351></feBlend><feBlend in=\"SourceGraphic\" in2=\"effect1_dropShadow_353_5142\" result=\"shape\" data-v-2d2fe351></feBlend></filter></defs>", 1)
const _hoisted_14 = { class: "Overlay__Corners" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  href: "#PhotoSettings-corner",
  x: 0,
  y: 0,
  width: "83",
  height: "84"
}, null, -1))
const _hoisted_16 = ["x", "transform"]
const _hoisted_17 = ["x", "y", "transform"]
const _hoisted_18 = ["y", "transform"]
const _hoisted_19 = {
  class: "Overlay__Grid",
  filter: "url(#PhotoSettings-gridShadow)"
}
const _hoisted_20 = ["x1", "y1", "y2"]
const _hoisted_21 = ["x1", "y1", "y2"]
const _hoisted_22 = ["x1", "x2", "y2"]
const _hoisted_23 = ["x1", "x2", "y2"]
const _hoisted_24 = ["x", "y"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M36.2377 0H16C7.16344 0 0 7.16346 0 16V66.1192C0 74.9558 7.16345 82.1192 16 82.1192H36.2377V81.1192H16C7.71574 81.1192 1 74.4035 1 66.1192V16C1 7.71574 7.71573 1 16 1H36.2377V0ZM73.3392 81.1192H93.5789C101.863 81.1192 108.579 74.4035 108.579 66.1192V16C108.579 7.71573 101.863 1 93.5789 1H73.3392V0H93.5789C102.415 0 109.579 7.16344 109.579 16V66.1192C109.579 74.9558 102.415 82.1192 93.5789 82.1192H73.3392V81.1192Z",
  fill: "white"
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M69.1246 44.086C67.742 50.4354 62.0983 55.1876 55.3492 55.1876C48.6001 55.1876 42.9564 50.4354 41.5738 44.086H40.5518C41.9509 50.9907 48.0443 56.1876 55.3492 56.1876C62.6542 56.1876 68.7475 50.9907 70.1466 44.086H69.1246ZM41.5738 38.0351C42.9562 31.6855 48.6 26.9332 55.3492 26.9332C62.0984 26.9332 67.7422 31.6855 69.1247 38.0351H70.1466C68.7477 31.1302 62.6542 25.9332 55.3492 25.9332C48.0442 25.9332 41.9507 31.1302 40.5518 38.0351H41.5738Z",
  fill: "white"
}, null, -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = ["x", "y"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.5882 0H6C2.68629 0 0 2.68629 0 6V22.5277C0 25.8414 2.6863 28.5277 6 28.5277H12.5882V27.5277H6C3.23858 27.5277 1 25.2891 1 22.5277V6C1 3.23858 3.23858 1 6 1H12.5882V0ZM25.4771 27.5277H32.067C34.8285 27.5277 37.067 25.2891 37.067 22.5277V6C37.067 3.23858 34.8285 1 32.067 1H25.4771V0H32.067C35.3808 0 38.067 2.68629 38.067 6V22.5277C38.067 25.8414 35.3808 28.5277 32.067 28.5277H25.4771V27.5277Z",
  fill: "white"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M23.3421 15.315C22.875 17.1575 21.2087 18.5187 19.2273 18.5187C17.246 18.5187 15.5796 17.1575 15.1126 15.315H14.087C14.5731 17.7135 16.6898 19.5187 19.2273 19.5187C21.7649 19.5187 23.8815 17.7135 24.3676 15.315H23.3421ZM15.1124 13.213C15.5793 11.3703 17.2458 10.0088 19.2273 10.0088C21.2089 10.0088 22.8754 11.3703 23.3422 13.213H24.3678C23.8819 10.8143 21.7651 9.00882 19.2273 9.00882C16.6896 9.00882 14.5728 10.8143 14.0869 13.213H15.1124Z",
  fill: "white"
}, null, -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "UI" }
const _hoisted_33 = { class: "Formats" }
const _hoisted_34 = { class: "Formats__Nav small-caps" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "Settings" }
const _hoisted_37 = ["title", "onClick", "onMouseenter"]
const _hoisted_38 = { class: "Actions" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "UIBtnShutter__Border",
  viewBox: "0 0 96 96",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "48",
    cy: "48",
    r: "47",
    "stroke-width": "2"
  })
], -1))
const _hoisted_40 = { class: "UIBtnShutter__Label small-caps" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Decoration Decoration--iso small-caps" }, [
  /*#__PURE__*/_createTextVNode(" ISO "),
  /*#__PURE__*/_createElementVNode("em", null, "400")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Decoration Decoration--focal small-caps" }, [
  /*#__PURE__*/_createElementVNode("em", null, "F 2.8")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Decoration Decoration--lens small-caps" }, [
  /*#__PURE__*/_createTextVNode(" Lens "),
  /*#__PURE__*/_createElementVNode("em", null, "35mm")
], -1))

import { ref, unref, computed, watch, ComputedRef, WritableComputedRef } from 'vue'
import { useActor } from '@xstate/vue'
import { gsap } from 'gsap'
import AppService from '@/store/states/AppService'
import Viewport from '@/store/modules/Viewport'
import { PaintingStore } from "@/store/modules/PaintingStore"

import UIBtnCamera from '@/components/UIBtn/UIBtnCamera.vue'
import InputRange, { DIRECTION as InputRangeDirection } from '@/components/PhotoSettings/InputRange.vue'
import { PhotoFormat, PhotoFormatDimensions } from '@/store/states/AppStateMachine'

import AudioManager from '@/core/audio/AudioManager'
import Gtm from '@/utils/Gtm'
import Browser from '@/utils/Browser'


// const enum FORMAT {
//   PORTRAIT = 'portrait',
//   LANDSCAPE = 'landscape',
//   SQUARE = 'square'
// }
const enum SETTING {
  BRIGHTNESS = 'brightness',
  CONTRAST = 'contrast',
  SATURATION = 'saturation',
  TEMPERATURE = 'temperature'
}

interface ISetting {
  name: SETTING
  value: WritableComputedRef<number>
  formattedValue: ComputedRef<string>
}

// const FORMATS: FORMAT[] = [FORMAT.PORTRAIT, FORMAT.LANDSCAPE, FORMAT.SQUARE]
// const SIZES = {
//   [FORMAT.LANDSCAPE]: {
//     width: 1024,
//     height: 770
//   },
//   [FORMAT.PORTRAIT]: {
//     width: 766,
//     height: 1024
//   },
//   [FORMAT.SQUARE]: {
//     width: 1024,
//     height: 1024
//   },
// }


import { defineComponent, onBeforeUnmount, onMounted } from 'vue'

const __default__ = defineComponent({})

function setup(__props) {

_useCssVars(_ctx => ({
  "3662299c": (_unref(PADDING).top),
  "e6af71a4": (_unref(PADDING).bottom),
  "95ea9c6c": (_unref(PADDING).left),
  "26bc2e8e": (_unref(PADDING).right),
  "448bdaae": (_unref(frame).height),
  "76a8175f": (_unref(frame).width)
}))

const FORMATS = [
  "landscape",
  "portrait",
  "square"
] as PhotoFormat[]


const PADDING = computed(() => {
  if (Viewport.isDesktop) {
    return {
      top: 56,
      right: 272,
      bottom: 56,
      left: 272,
    }
  }

  return {
    top: 85,
    right: 8,
    bottom: 258,
    left: 8,
  }
})

function getSizeToFit(inWidth: number, inHeight: number, outWidth: number, outHeight: number): { width: number, height: number } {
  const inRatio = inWidth / inHeight
  const outRatio = outWidth / outHeight

  let width = outWidth
  let height = outHeight

  if (inRatio > outRatio) {
    height = outWidth / inRatio
  } else if (inRatio < outRatio) {
    width = outHeight * inRatio
  }

  return { width, height }
}

const { send, state } = useActor(AppService)

const currentFormat = computed({
  get: () => state.value.context.povDatas.format,
  set(format: PhotoFormat) {
    send({ type: 'UPDATE_POV_DATA', pov: { format } })
  }
})

const viewBox = computed(() => `0 0 ${Viewport.windowWidth} ${Viewport.windowHeight}`)

const frameWidth = ref(PhotoFormatDimensions[currentFormat.value].width)
const frameHeight = ref(PhotoFormatDimensions[currentFormat.value].height)

watch(currentFormat, (format) => {
  // animate format update
  const { width, height } = PhotoFormatDimensions[format]
  const anim = { duration: 0.45, ease: 'cubic' }
  gsap.to(frameWidth, { value: width, ...anim })
  gsap.to(frameHeight, { value: height, ...anim })
})

const frame = computed(() => {
  const padding = unref(PADDING)
  const containerWidth = (Viewport.windowWidth - (padding.left + padding.right))
  const containerHeight = (Viewport.windowHeight - (padding.top + padding.bottom))

  const { width, height } = getSizeToFit(
    unref(frameWidth),
    unref(frameHeight),
    containerWidth,
    containerHeight
  )

  const x = padding.left + containerWidth / 2 - width / 2
  const y = padding.top + containerHeight / 2 - height / 2

  PaintingStore.frame.x = x;
  PaintingStore.frame.y = y;
  PaintingStore.frame.width = width;
  PaintingStore.frame.height = height;

  return { x, y, width, height }
})

const settingsMapper = gsap.utils.pipe(
  gsap.utils.interpolate(-100, 100),
  gsap.utils.snap(1),
  (v: number) => Math.sign(v) > 0 ? `+${v}` : `${v}`
)

const contrast = computed({
  get: () => state.value.context.povDatas.contrast,
  set(contrast: number) {
    send({ type: 'UPDATE_POV_DATA', pov: { contrast } })

    Gtm.sendEventPush(
      'camera-mode-setting',
      'change-preset',
      'Contrast',
      contrast
    )
  }
})
const contrastLabel = computed(() => settingsMapper(contrast.value))

const saturation = computed({
  get: () => state.value.context.povDatas.saturation,
  set(saturation: number) {
    send({ type: 'UPDATE_POV_DATA', pov: { saturation } })

    Gtm.sendEventPush(
      'camera-mode-setting',
      'change-preset',
      'Saturation',
      saturation
    )
  }
})
const saturationLabel = computed(() => settingsMapper(saturation.value))

const brightness = computed({
  get: () => state.value.context.povDatas.brightness,
  set(brightness: number) {
    send({ type: 'UPDATE_POV_DATA', pov: { brightness } })
    Gtm.sendEventPush(
      'camera-mode-setting',
      'change-preset',
      'Brightness',
      brightness
    )
  }
})
const brightnessLabel = computed(() => settingsMapper(brightness.value))

const temperature = computed({
  get: () => state.value.context.povDatas.temperature,
  set(temperature: number) {
    send({ type: 'UPDATE_POV_DATA', pov: { temperature } })

    Gtm.sendEventPush(
      'camera-mode-setting',
      'change-preset',
      'Warmth',
      temperature
    )
  }
})
const temperatureLabel = computed(() => settingsMapper(temperature.value))

const zoom = computed({
  get: () => state.value.context.povDatas.zoom,
  set(zoom: number) {
    send({ type: 'UPDATE_POV_DATA', pov: { zoom } })

    Gtm.sendEventPush(
      'camera-mode-setting',
      'zoom',
      'Change zoom',
      zoom
    )
  }
})
const zoomMapper = gsap.utils.pipe(
  gsap.utils.interpolate([0.5, 1, 2]),
  gsap.utils.snap(0.1),
  (v: number) => `x${v}`
)
const zoomLabel = computed(() => zoomMapper(zoom.value))

const SETTINGS: ISetting[] = [
  {
    name: SETTING.BRIGHTNESS,
    value: brightness,
    formattedValue: brightnessLabel
  },
  {
    name: SETTING.CONTRAST,
    value: contrast,
    formattedValue: contrastLabel
  },
  {
    name: SETTING.SATURATION,
    value: saturation,
    formattedValue: saturationLabel
  },
  {
    name: SETTING.TEMPERATURE,
    value: temperature,
    formattedValue: temperatureLabel
  },
]

const currentSetting = ref(SETTINGS[0])
const tempSetting = ref(SETTINGS[0])
const isSettingsOpen = ref(true)

function changeFormat(format) {
  currentFormat.value = format
  Gtm.sendEventPush(
    'camera-mode-setting',
    'change-ratio',
    `${format}`
  )
}

function capture() {

  playUI('ui_click_camera_snap')
  
  send('SUBMIT')
  Gtm.sendVPV('photo')

  Gtm.sendEventPush(
    'camera-mode',
    'take-photo',
    'Take photo',
  )

  let device = Browser.oculus ? 'xr' : Browser.mobile ? 'mobile' : 'desktop'

  Gtm.sendTakePicture(
    `take-photo-${device}`,
    saturation.value,
    brightness.value,
    contrast.value,
    temperature.value,
    currentFormat.value,
    zoom.value
  )
}

function onEnter() {
  

  const $ = gsap.utils.selector('.PhotoSettings')
  const tl = gsap.timeline({
    onComplete: () => {
      gsap.set([$('.Formats__Btn')], {
        clearProps: 'all'
      })
    }
  })
  tl
    .from($('.Overlay'), {
      autoAlpha: 0,
      scale: 1.1,
      duration: 0.9,
      ease: 'expo.inOut'
    }, 'start')
    .from($('.UIBtnCamera'), {
      scale: 0.8,
      autoAlpha: 0,
      duration: 0.8,
      ease: 'customOut3'
    }, 'start+=0.4')
    .from([$('.Decoration'), $('.Formats__Btn')], {
      autoAlpha: 0,
      duration: 0.6,
      stagger: 0.02,
      ease: 'customOut'
    }, 'start+=0.6')

    .from($('.Settings__MenuItem'), {
      scale: 0.4,
      autoAlpha: 0,
      duration: 0.8,
      transition: 'none',
      ease: 'customOut3',
      stagger: 0.02
    }, 'start+=0.6')
    .from([$('.InputRange')], {
      autoAlpha: 0,
      duration: 0.6,
      stagger: 0.02,
      ease: 'customOut'
    }, 'start+=0.8')
    .from([$('.UIBtnShutter')], {
      autoAlpha: 0,
      scale: 0.6,
      duration: 0.6,
      ease: 'customOut3',
    }, 'start+=0.8')
    .from([$('.UIBtnShutter__Label')], {
      autoAlpha: 0,
      duration: 0.6,
      ease: 'customOut3',
    }, 'start+=0.9')
}

onMounted(() => {
  onEnter()
})

function playUI(name){
  AudioManager.playUI(name);
}

function onCancel() {
  send('CANCEL')
  Gtm.sendEventPush(
    'immersive-painting',
    'camera-mode',
    `Close camera mode`
  )
}

onBeforeUnmount(() => {
  
})


return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("defs", null, [
        (_unref(Viewport).isDesktop)
          ? (_openBlock(), _createElementBlock("symbol", _hoisted_3, _hoisted_6))
          : (_openBlock(), _createElementBlock("symbol", _hoisted_7, _hoisted_9))
      ]),
      _createElementVNode("mask", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("rect", _mergeProps({
          fill: "black",
          rx: "24"
        }, _unref(frame)), null, 16)
      ]),
      _hoisted_12,
      (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(frame))), [
        _hoisted_13,
        _createElementVNode("g", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("use", {
            href: "#PhotoSettings-corner",
            x: _unref(frame).width - 83,
            y: 0,
            width: "83",
            height: "84",
            transform: `rotate(90 ${_unref(frame).width - 83 / 2} ${84 / 2})`
          }, null, 8, _hoisted_16),
          _createElementVNode("use", {
            href: "#PhotoSettings-corner",
            x: _unref(frame).width - 83,
            y: _unref(frame).height - 84,
            width: "83",
            height: "84",
            transform: `rotate(180 ${_unref(frame).width - 83 / 2} ${_unref(frame).height - 84 / 2})`
          }, null, 8, _hoisted_17),
          _createElementVNode("use", {
            href: "#PhotoSettings-corner",
            x: 0,
            y: _unref(frame).height - 83,
            width: "83",
            height: "84",
            transform: `rotate(-90 ${83 / 2} ${_unref(frame).height - 84 / 2})`
          }, null, 8, _hoisted_18)
        ]),
        _createElementVNode("g", _hoisted_19, [
          _createElementVNode("line", {
            x1: _unref(frame).width,
            y1: _unref(frame).height * 2 / 3,
            x2: "0",
            y2: _unref(frame).height * 2 / 3
          }, null, 8, _hoisted_20),
          _createElementVNode("line", {
            x1: _unref(frame).width,
            y1: _unref(frame).height * 1 / 3,
            x2: "0",
            y2: _unref(frame).height * 1 / 3
          }, null, 8, _hoisted_21),
          _createElementVNode("line", {
            x1: _unref(frame).width * 1 / 3,
            y1: "0",
            x2: _unref(frame).width * 1 / 3,
            y2: _unref(frame).height
          }, null, 8, _hoisted_22),
          _createElementVNode("line", {
            x1: _unref(frame).width * 2 / 3,
            y1: "0",
            x2: _unref(frame).width * 2 / 3,
            y2: _unref(frame).height
          }, null, 8, _hoisted_23)
        ]),
        (_unref(Viewport).isDesktop)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 0,
              class: "Overlay__Crosshairs",
              x: _unref(frame).width / 2 - 110 / 2,
              y: _unref(frame).height / 2 - 83 / 2,
              width: "110",
              height: "83",
              viewBox: "0 0 110 83",
              fill: "none"
            }, _hoisted_27, 8, _hoisted_24))
          : (_openBlock(), _createElementBlock("svg", {
              key: 1,
              class: "Overlay__Crosshairs",
              x: _unref(frame).width / 2 - 39 / 2,
              y: _unref(frame).height / 2 - 29 / 2,
              width: "39",
              height: "29",
              viewBox: "0 0 39 29",
              fill: "none"
            }, _hoisted_31, 8, _hoisted_28))
      ], 16))
    ])),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("ul", _hoisted_34, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FORMATS), (format) => {
            return (_openBlock(), _createElementBlock("li", {
              key: format,
              class: "Formats__Item"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["Formats__Btn", { 'is-active': _unref(currentFormat) === format }]),
                onClick: ($event: any) => (changeFormat(format))
              }, _toDisplayString(_ctx.$t(`painting.photo.format_${format}`)), 11, _hoisted_35)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(UIBtnCamera, {
          type: "button",
          active: isSettingsOpen.value,
          onClick: onCancel
        }, null, 8, ["active"]),
        _createElementVNode("ul", {
          class: _normalizeClass(["Settings__Menu", { 'is-open': isSettingsOpen.value }])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SETTINGS, (setting) => {
            return _createElementVNode("li", {
              key: setting.name,
              class: "Settings__MenuItem"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["Settings__Btn", { 'is-active': currentSetting.value.name === setting.name }]),
                title: _ctx.$t(`painting.photo.${setting.name}`),
                onClick: ($event: any) => {playUI('ui_click_camera_function');currentSetting.value = setting; tempSetting.value = currentSetting.value;},
                onMouseenter: ($event: any) => {playUI('ui_rollover_switch'); tempSetting.value = currentSetting.value; currentSetting.value = setting},
                onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (currentSetting.value = tempSetting.value))
              }, [
                _createVNode(_component_ui_icon, {
                  name: setting.name
                }, null, 8, ["name"])
              ], 42, _hoisted_37)
            ])
          }), 64))
        ], 2),
        _createVNode(InputRange, {
          name: currentSetting.value.name,
          label: _ctx.$t(`painting.photo.${currentSetting.value.name}`),
          modelValue: currentSetting.value.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentSetting.value.value) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(currentSetting.value.formattedValue), 1)
          ]),
          _: 1
        }, 8, ["name", "label", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(InputRange, {
          name: "zoom",
          label: _ctx.$t('painting.photo.zoom'),
          step: "0.1",
          direction: _unref(InputRangeDirection).VERTICAL,
          reversed: true,
          onInput: _cache[2] || (_cache[2] = ($event: any) => {playUI('ui_zoom_adjust');}),
          modelValue: _unref(zoom),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(zoom) ? (zoom).value = $event : null))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(zoomLabel)), 1)
          ]),
          _: 1
        }, 8, ["label", "direction", "modelValue"]),
        _createElementVNode("button", {
          type: "button",
          class: "UIBtnShutter",
          onClick: capture
        }, [
          _hoisted_39,
          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('painting.photo.cta_submit')), 1)
        ])
      ]),
      _hoisted_41,
      _hoisted_42,
      _hoisted_43
    ])
  ]))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup})